import React from 'react';
import './TracknTone.css';
import tracknToneLogo from '../assets/images/trackntone_1024.png';

function TracknTone() {
  return (
    <div className="trackntone-page">
      <section className="trackntone-hero">
        <div className="trackntone-hero-inner">
          <img
            src={tracknToneLogo}
            alt="TracknTone logo"
            className="trackntone-logo-wow"
          />
          <h1>TracknTone</h1>
          <p>
            A health companion that helps you log meals, understand your progress, and stay motivated.
          </p>
        </div>
      </section>

      <section className="trackntone-content">
        <h2>What you can do</h2>
        <ul>
          <li>Log meals by scanning a photo and confirming the estimate.</li>
          <li>Track your daily signals (steps, water, calories) and goals.</li>
          <li>Optional private Circles with buddies for encouragement.</li>
        </ul>

        <h2>Learn more</h2>
        <p className="trackntone-links">
          Explore our{" "}
          <a href="/trackntone/privacy">Privacy Policy</a> and{" "}
          <a href="/trackntone/terms">Terms of Service</a>.
        </p>

        <h2>Health information disclaimer</h2>
        <p className="trackntone-disclaimer">
          <strong>Not medical advice.</strong> TracknTone provides general information and
          coaching-style insights. It is not intended to diagnose, treat, cure, or prevent any
          medical condition. Always consult a qualified healthcare professional for medical
          advice.
        </p>

        <h2>Company contact</h2>
        <p>
          Email: <a href="mailto:tnt@northhawks.ca">tnt@northhawks.ca</a>
        </p>
      </section>
    </div>
  );
}

export default TracknTone;

